<template>
	<div class="v-search-profile-form">
		<div class="form__heading">
			<h2 class="form__title">{{ searchProfileTitle }}</h2>
		</div>
		<ul class="form__list">
			<v-form-list-replicator ref="replicator" :min="1">
				<template slot-scope="props">
					<li class="form__item" v-for="i in props.count">
						<v-autocomplete-public name='location_id[]' :label="spCityTitle"
							endpoint="/admin/autocomplete/locations" v-validate="`location`">
						</v-autocomplete-public>
					</li>
				</template>
			</v-form-list-replicator>
			<li class="form__item form__item-legend" v-if="website == 'athome'">
				<button type="button" class="form__button form__button--replicate"
					@click="$refs.replicator.replicate()">
					<i class="fa fa-plus" aria-hidden="true"></i>
					{{ spAdd }}
				</button>
				<button type="button" class="form__button form__button--replicate" @click="$refs.replicator.reduce()">
					<i class="fa fa-minus" aria-hidden="true"></i>
					{{ spReduce }}
				</button>
			</li>
			<v-form-list-replicator ref="districtReplicator" :min="1">
				<template slot-scope="props">
					<li class="form__item" v-for="i in props.count">
						<v-textfield-public name='districts[]' :label="spDistrictTitle">
						</v-textfield-public>
					</li>
				</template>
			</v-form-list-replicator>
			<li class="form__item form__item-legend">
				<button type="button" class="form__button form__button--replicate"
					@click="$refs.districtReplicator.replicate()">
					<i class="fa fa-plus" aria-hidden="true"></i>
					{{ spAdd }}
				</button>
				<button type="button" class="form__button form__button--replicate"
					@click="$refs.districtReplicator.reduce()">
					<i class="fa fa-minus" aria-hidden="true"></i>
					{{ spReduce }}
				</button>
			</li>
			<li class="form__item">
				<v-select-public :label="spDistanceTitle" :value="spDistanceValue" name="distance"
					:options="spDistanceOptions">
				</v-select-public>
			</li>
			<template v-if="website == 'athome'">
				<li class="form__item">
					<div class="form__row">
						<div class="form__column">
							<v-select-public :label="spRentalPriceFromTitle" :value="spRentalPriceFromValue"
								name="min_price" :options="spRentalPriceFromOptions" @change="getPrice($event, price)">
							</v-select-public>
						</div>
						<div class="form__column">
							<v-select-public :label="spRentalPriceToTitle" :value="spRentalPriceToValue"
								name="max_price" :options="spRentalPriceToOptions" v-validate="`required`">
							</v-select-public>
						</div>
					</div>
				</li>
				<li class="form__item">
					<div class="form__row">
						<div class="form__column">
							<v-select-public :label="spBedroomsTitle" :value="spBedroomsValue"
								name="min_number_of_bedrooms" :options="spBedroomsOptions" v-validate="`required`">
							</v-select-public>
						</div>
						<div class="form__column">
							<v-select-public :label="spSurfaceTitle" :value="spSurfaceValue" name="min_area"
								:options="spSurfaceOptions" v-validate="`required`">
							</v-select-public>
						</div>
					</div>
				</li>
				<li class="form__item">
					<div class="form__row">
						<div class="form__column">
							<v-select-public :label="spPropertyTypeTitle" :value="spPropertyTypeValue"
								name="property_type_id" value="0" :zero-option="spNoPreference"
								:options="spPropertyTypeOptions" v-validate="`required`">
							</v-select-public>
						</div>
						<div class="form__column">
							<v-select-public :label="spInteriorTitle" :value="spInteriorValue" name="furnishing_id"
								value="0" :zero-option="spNoPreference" :options="spInteriorOptions"
								v-validate="`required`">
							</v-select-public>
						</div>
					</div>
				</li>
				<li class="form__item">
					<div class="form__row">
						<div class="form__column">
							<v-select-public :label="spSuitableForSharingTitle" :value="spSuitableForSharingValue"
								name="require_beeing_sharable" :options="spSuitableForSharingOptions"
								v-validate="`required`">
							</v-select-public>
						</div>
						<div class="form__column">
							<v-select-public :label-html="spParkingSpaceTitle" :value="spParkingSpaceValue"
								name="require_parking" :options="spParkingSpaceOptions" v-validate="`required`">
							</v-select-public>
						</div>
					</div>
				</li>
				<li class="form__item">
					<v-select-public :label="spRentPeriodTitle" :value="spRentPeriodValue" name="rental_period_id"
						value="0" :zero-option="spNoPreference" :options="spRentPeriodOptions" v-validate="`required`">
					</v-select-public>
				</li>
				<li class="form__item">
					<v-datepicker-public :label="spStartDateRentTitle" name="rental_starts_at"
						:value="spStartDateRentValue" v-validate="`required`">
					</v-datepicker-public>
				</li>
			</template>
			<template v-else>
				<li class="form__item">
					<v-textfield-public :label="spRentalTextTitle" name="rental_text">
					</v-textfield-public>
				</li>
				<li class="form__item">
					<div class="form__row">
						<div class="form__column">
							<v-datepicker-public :label="spStartDateRentTitle" name="rental_starts_at"
								:value="spStartDateRentValue" v-validate="`required`">
							</v-datepicker-public>
						</div>
						<div class="form__column">
							<v-textfield-public :label="spWeekPriceTitle" name="week_price" placeholder="in euro"
								type="number" v-validate="`required`">
							</v-textfield-public>
						</div>
					</div>
				</li>
				<li class="form__item">
					<div class="form__row">
						<div class="form__column">
							<v-textfield-public :label="spNumberOfMenTitle" name="number_of_men" type="number"
								v-validate="`required`">
							</v-textfield-public>
						</div>
						<div class="form__column">
							<v-textfield-public :label="spNumberOfWomenTitle" name="number_of_women" type="number"
								v-validate="`required`">
							</v-textfield-public>
						</div>
					</div>
				</li>
				<li class="form__item">
					<div class="form__row">
						<div class="form__column">
							<v-select-public :label="spMinNumberOfBedroomsTitle" :value="spBedroomsValue"
								name="min_number_of_bedrooms" :options="spBedroomsOptions" v-validate="`required`">
							</v-select-public>
						</div>
						<div class="form__column">
							<v-select-public :label="spParkingPlacesTitle" :value="'0'" name="parking_places"
								:options="spParkingPlacesOptions" v-validate="`required`">
							</v-select-public>
						</div>
					</div>
				</li>
			</template>
			<li class="form__item form__item--align-start">
				<label class="form__label">
					{{ spExtraInformationTitle }}
				</label>
				<textarea class="form__textarea" name="searchprofile_subscriber_note">
				</textarea>
			</li>
		</ul>
	</div>
</template>
<script>

export default {
	inject: ['$validator'],
	data() {
		return {
			guarantor_form_state: -1,
			price: ''
		}
	},
	props: {
		website: {
			default: '',
			type: String
		},
		searchProfileTitle: {
			default: '',
			type: String
		},
		spDistanceTitle: {
			default: '',
			type: String
		},
		spDistanceOptions: {
			default: () => { },
			type: Object
		},
		spDistanceValue: {
			default: '',
			type: String
		},
		spCityTitle: {
			default: '',
			type: String
		},
		spDistrictTitle: {
			default: '',
			type: String
		},
		spRentalPriceFromTitle: {
			default: '',
			type: String
		},
		spRentalPriceFromOptions: {
			default: () => { },
			type: Object
		},
		spRentalPriceFromValue: {
			default: '',
			type: String
		},
		spRentalPriceToTitle: {
			default: '',
			type: String
		},
		spRentalPriceToOptions: {
			default: () => { },
			type: Object
		},
		spRentalPriceToValue: {
			default: '',
			type: String
		},
		spBedroomsTitle: {
			default: '',
			type: String
		},
		spBedroomsOptions: {
			default: () => { },
			type: Object
		},
		spBedroomsValue: {
			default: '',
			type: String
		},
		spSurfaceTitle: {
			default: '',
			type: String
		},
		spSurfaceOptions: {
			default: () => { },
			type: Object
		},
		spSurfaceValue: {
			default: '',
			type: String
		},
		spPropertyTypeTitle: {
			default: '',
			type: String
		},
		spPropertyTypeOptions: {
			default: () => { },
			type: Object
		},
		spPropertyTypeValue: {
			default: '',
			type: String
		},
		spInteriorTitle: {
			default: '',
			type: String
		},
		spInteriorOptions: {
			default: () => { },
			type: Object
		},
		spInteriorValue: {
			default: '',
			type: String
		},
		spSuitableForSharingTitle: {
			default: '',
			type: String
		},
		spSuitableForSharingOptions: {
			default: () => { },
			type: Object
		},
		spSuitableForSharingValue: {
			default: '',
			type: String
		},
		spParkingSpaceTitle: {
			default: '',
			type: String
		},
		spParkingSpaceOptions: {
			default: () => { },
			type: Object
		},
		spParkingSpaceValue: {
			default: '',
			type: String
		},
		spRentPeriodTitle: {
			default: '',
			type: String
		},
		spRentPeriodOptions: {
			default: () => { },
			type: Object
		},
		spRentPeriodValue: {
			default: '',
			type: String
		},
		spStartDateRentTitle: {
			default: '',
			type: String
		},
		spStartDateRentValue: {
			default: '',
			type: String
		},
		spExtraInformationTitle: {
			default: '',
			type: String
		},
		spNoPreference: {
			default: '',
			type: String
		},
		spAdd: {
			default: '',
			type: String
		},
		spReduce: {
			default: '',
			type: String
		},
		spRentalTextTitle: {
			default: '',
			type: String
		},
		spWeekPriceTitle: {
			default: '',
			type: String
		},
		spNumberOfMenTitle: {
			default: '',
			type: String
		},
		spNumberOfWomenTitle: {
			default: '',
			type: String
		},
		spMinNumberOfBedroomsTitle: {
			default: '',
			type: String
		},
		spParkingPlacesTitle: {
			default: '',
			type: String
		},
		spParkingPlacesOptions: {
			default: () => { },
			type: Object
		}
	},
	methods: {
		getPrice(price) {
			const input = document.getElementById('requestSrcCheckbox'),
				infoItem = document.querySelector('.func-request-src-item');

			if (parseInt(price) < 1500) {
				input.disabled = true;
				input.checked = false;
				infoItem.classList.remove('form-checkbox-info--hidden');
				input.closest('.v-checkbox__item').classList.add('v-checkbox__item--disabled');
			} else {
				input.disabled = false;
				infoItem.classList.add('form-checkbox-info--hidden');
				input.closest('.v-checkbox__item').classList.remove('v-checkbox__item--disabled');
			}
		}
	}
}
</script>